import React, { useState, useEffect } from "react";
import WadeLogo from "../../../../components/Icons/WadeLogo.svg";
import Input from "../../../Input/Input";
import AuthLayout from "../../AuthLayout";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPasswordService } from "../../../../services/resetPassword.service";
import PasswordInput from "../../../PasswordInput/PasswordInput";
import PasswordResetMessage from "../../Message/PasswordResetMessage/PasswordResetMessage";

const ResetPassword = () => {
  const [passwordInput, setPasswordInput] = useState("");
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("");
  const [passwordResetTokenEmpty, setPasswordResetTokenEmpty] = useState(false);
  const [wrongPasswordResetToken, setWrongPasswordResetToken] = useState(false);

  const [passwordResetToken, setPasswordResetToken] = useState("");
  const [createPasswordEmpty, setCreatePasswordEmpty] = useState(false);
  const [confirmPasswordEmpty, setConfirmPasswordEmpty] = useState(false);
  const [createAndConfirmPasswordEmpty, setCreateAndConfirmPasswordEmpty] =
    useState(false);
  const [
    createAndConfirmPasswordMismatch,
    setCreateAndConfirmPasswordMismatch,
  ] = useState(false);
  const [
    incorrectcreatePasswordInputChange,
    setIncorrectcreatePasswordInputChange,
  ] = useState(false);
  const [
    incorrectconfirmPasswordInputChange,
    setIncorrectconfirmPasswordInputChange,
  ] = useState(false);
  const [incorrectresettokenInputChange, setIncorrectTokenInputChange] =
    useState(false);
  const [passwordCriteriaMismatch, setPasswordCriteriaMismatch] =
    useState(false);
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const regexPasswordPattern = /^.{8,90}$/;

  useEffect(() => {
    localStorage.removeItem("isLoggedIn");
  }, []);

  const handlePasswordChange = (evnt: any) => {
    if (createPasswordEmpty === true) {
      setIncorrectcreatePasswordInputChange(false);
    }
    setIncorrectcreatePasswordInputChange(true);
    setPasswordInput(evnt.target.value);
  };
  const handleConfirmPasswordChange = (evnt: any) => {
    if (createPasswordEmpty === true) {
      setIncorrectconfirmPasswordInputChange(false);
    }
    setIncorrectconfirmPasswordInputChange(true);
    setConfirmPasswordInput(evnt.target.value);
  };

  const handlePasswordResetTokenChange = (evnt: any) => {
    if (createPasswordEmpty === true) {
      setIncorrectTokenInputChange(false);
    }
    setIncorrectTokenInputChange(true);
    setPasswordResetToken(evnt.target.value);
  };

  const passwordCreationHandler = () => {
    setWrongPasswordResetToken(false);
    setPasswordCriteriaMismatch(false);
    setIncorrectcreatePasswordInputChange(false);
    setIncorrectconfirmPasswordInputChange(false);
    setIncorrectTokenInputChange(false);
    setCreatePasswordEmpty(false);
    setConfirmPasswordEmpty(false);
    setCreateAndConfirmPasswordEmpty(false);
    setPasswordResetTokenEmpty(false);
    setCreateAndConfirmPasswordMismatch(false);
    if (
      passwordInput === "" &&
      confirmPasswordInput === "" &&
      passwordResetToken === ""
    ) {
      setPasswordResetTokenEmpty(true);
      setCreateAndConfirmPasswordEmpty(true);
    } else if (passwordInput === "" && confirmPasswordInput === "") {
      setCreateAndConfirmPasswordEmpty(true);
    } else if (passwordInput === "" && passwordResetToken === "") {
      setCreatePasswordEmpty(true);
      setPasswordResetTokenEmpty(true);
    } else if (passwordInput === "") {
      setCreatePasswordEmpty(true);
    } else if (confirmPasswordInput === "" && passwordResetToken === "") {
      setConfirmPasswordEmpty(true);
      setPasswordResetTokenEmpty(true);
    } else if (
      passwordInput !== confirmPasswordInput &&
      passwordResetToken === ""
    ) {
      setCreateAndConfirmPasswordMismatch(true);
      setPasswordResetTokenEmpty(true);
    } else if (confirmPasswordInput === "") {
      setConfirmPasswordEmpty(true);
    } else if (passwordResetToken === "") {
      setPasswordResetTokenEmpty(true);
    } else if (passwordInput !== confirmPasswordInput) {
      setCreateAndConfirmPasswordMismatch(true);
    } else if (
      !regexPasswordPattern.test(passwordInput) ||
      !regexPasswordPattern.test(confirmPasswordInput)
    ) {
      setPasswordCriteriaMismatch(true);
    } else {
      resetPasswordService(
        location.state?.emailUserID || "",
        passwordInput,
        passwordResetToken
      )
        .then(() => {
          setModalShow(true);
        })
        .catch((res) => {
          if (res.status === 401) {
            setWrongPasswordResetToken(true);
          }
        });
    }
  };
  return (
    <AuthLayout>
      <div className="tw-w-full tw-max-w-md tw-flex tw-flex-col tw-items-center">
        <img
          src={WadeLogo}
          alt="WADELOGO"
          className="tw-h-12 tw-mb-12"
        />
        <div className="tw-text-3xl tw-font-semibold tw-text-[#03234a] tw-mb-8">Reset Password</div>

        <div className="tw-w-full tw-flex tw-flex-col tw-gap-6">
          <div className="tw-w-full">
            <PasswordInput
              id={`${incorrectcreatePasswordInputChange
                ? "tw-border-[#e88181] tw-text-[#e88181]"
                : `${createPasswordEmpty ||
                  createAndConfirmPasswordEmpty ||
                  createAndConfirmPasswordMismatch ||
                  passwordCriteriaMismatch
                  ? "tw-border-[#e88181] tw-text-[#e88181]"
                  : ""
                }`
                }`}
              // Removed className as it is not supported
              labelId="tw-text-[#03234a] tw-font-medium tw-mb-2"
              label="Create New Password"
              name="Create New Password"
              type="password"
              placeholder="Password"
              ariaDescribedBy="Enter Password"
              infoIcon={true}
              infoMessage={`Password must be at least 8 characters.`}
              value={passwordInput}
              maxlength={100}
              isDisabled={false}
              onChange={(e) => handlePasswordChange(e)}
              isError={
                !incorrectcreatePasswordInputChange &&
                (createPasswordEmpty ||
                  createAndConfirmPasswordEmpty ||
                  createAndConfirmPasswordMismatch ||
                  passwordCriteriaMismatch)
              }
            />
            {createPasswordEmpty && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Create new Password cannot be empty. Please enter Create new
                Password
              </div>
            )}
            {passwordCriteriaMismatch && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Password does not meet the criteria. Please try again
              </div>
            )}
          </div>

          <div className="tw-w-full">
            <PasswordInput
              id={`${incorrectconfirmPasswordInputChange
                ? "tw-border-[#e88181] tw-text-[#e88181]"
                : `${confirmPasswordEmpty ||
                  createAndConfirmPasswordEmpty ||
                  createAndConfirmPasswordMismatch ||
                  passwordCriteriaMismatch
                  ? "tw-border-[#e88181] tw-text-[#e88181]"
                  : ""
                }`
                }`}
              // Removed className as it is not supported
              labelId="tw-text-[#03234a] tw-font-medium tw-mb-2"
              label="Confirm Password"
              name="Confirm Password"
              infoIcon={true}
              infoMessage={`Password must be at least 8 characters.`}
              type="password"
              placeholder="Password"
              ariaDescribedBy="Enter Password"
              value={confirmPasswordInput}
              maxlength={100}
              isDisabled={false}
              onChange={(e) => handleConfirmPasswordChange(e)}
              isError={
                !incorrectconfirmPasswordInputChange &&
                (confirmPasswordEmpty ||
                  createAndConfirmPasswordEmpty ||
                  createAndConfirmPasswordMismatch ||
                  passwordCriteriaMismatch)
              }
            />
            {confirmPasswordEmpty && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Confirm Password cannot be empty. Please enter Confirm Password
              </div>
            )}
            {createAndConfirmPasswordEmpty && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Create Password and Confirm Password cannot be empty. Please
                Enter it
              </div>
            )}
            {createAndConfirmPasswordMismatch && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Create new password and Confirm password are mismatched. Please
                verify
              </div>
            )}
            {passwordCriteriaMismatch && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Password does not meet the criteria. Please try again
              </div>
            )}
          </div>

          <div className="tw-w-full">
            <Input
              id={`${incorrectresettokenInputChange
                ? "tw-border-[#e88181] tw-text-[#e88181]"
                : passwordResetTokenEmpty
                  ? "tw-border-[#e88181] tw-text-[#e88181]"
                  : ""
                }`}
              inputClassName="form-control" // Correct prop for styling the input element
              labelId="tw-text-[#03234a] tw-font-medium tw-mb-2"
              label="Password Reset Token"
              name="Password Reset Token"
              type="text"
              placeholder="Enter reset token"
              ariaDescribedBy="Enter reset token"
              value={passwordResetToken}
              maxlength={100}
              isDisabled={false}
              onChange={(e) => handlePasswordResetTokenChange(e)}
            />

            {passwordResetTokenEmpty && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Password reset token cannot be empty. Please enter Password
                reset token
              </div>
            )}
            {wrongPasswordResetToken && (
              <div className="tw-text-[#e88181] tw-text-sm tw-mt-1">
                Invalid Password reset token. Please try again.
              </div>
            )}
          </div>
        </div>

        <button
          type="button"
          onClick={passwordCreationHandler}
          className="tw-w-full tw-h-12 tw-bg-[#03234a] tw-text-[#d0fb56] tw-font-bold tw-rounded-md hover:tw-bg-[#021833] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] tw-transition-all tw-shadow-md active:tw-transform active:tw-scale-[0.98] tw-mt-8"
        >
          PROCEED
        </button>

        <div className="tw-absolute tw-bottom-6 tw-text-xs tw-text-[#03234a] tw-text-center tw-w-full">
          <span>©2023 All Rights Reserved</span>
          <span className="tw-mx-4">|</span>
          <a href="https://wadeinsight.com/privacy-policy/" target="_blank" className="tw-text-[#03234a] tw-no-underline hover:tw-underline">
            Privacy Policy
          </a>
        </div>
      </div>
      <PasswordResetMessage
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          navigate("/");
        }}
      />
    </AuthLayout>
  );
};

export default ResetPassword;
